import React, { useState } from "react";
import { Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { getContacts, getUser } from "../../../../reducers";
import rmsActions from "../../../../actions/rmsActions";


function MessageForm(props) {
    return (
        <Dialog
            open={!!props.open}
            onClose={props.onClose}
            fullWidth={true}
            maxWidth="md"
        >
            <DialogTitle>New message</DialogTitle>
            <DialogContent dividers={false}>
                <Box
                    component="form"
                    autoComplete="off"
                    noValidate
                    className="dialog-content"
                    onSubmit={e => e.preventDefault()}
                >
                    <Grid container spacing={3}>

                        <Grid item xs={12} sm={12} md={12}>
                            <Autocomplete
                                id="text-to"
                                freeSolo
                                onChange={(event, value) => props.setTo(value)}
                                options={props.contacts.map(({name}) => name)}
                                renderInput={(params) => <TextField {...params} label="To" onChange={({target}) => props.onChange(target.value)} required/>}
                                multiple
                                fullWidth
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={12}>
                            <TextField
                                variant="outlined"
                                id="text-subject"
                                label="Subject"
                                value={props.subject}
                                onChange={({target}) => props.setSubject(target.value)}
                                fullWidth
                                required
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={12}>
                            <TextField
                                variant="outlined"
                                id="text-body"
                                label="Message"
                                value={props.body}
                                onChange={({target}) => props.setBody(target.value)}
                                multiline
                                rows={6}
                                fullWidth
                                required
                            />
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button key="cancel" onClick={props.onClose}>Cancel</Button>
                <Button
                    key="save"
                    variant="contained"
                    color="primary"
                    onClick={props.onSubmit}
                    disabled={!props.to?.length || !props.subject|| !props.body}
                >
                    Send
                </Button>
            </DialogActions>
        </Dialog>
    );
}


function MessageFormContainer({onSave, onClose, appCode, ...props}) {

    const dispatch = useDispatch();

    const [to, setTo] = useState([]);
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState('');

    const contacts = useSelector((state) => getContacts(state)) || [];
    const user = useSelector((state) => getUser(state));

    const onChange = (searchText) => {
        if (searchText.length > 2) {
            dispatch(rmsActions.getContacts(appCode, searchText));
        }
    }

    const onSubmit = () => {
        const params = {
            to: contacts.filter(({name}) => to.includes(name)),
            from: { uuid: user.uuid, email: user.email },
            subject,
            body
        };
        onSave(params);
        onClose();
    };

    return (
        <MessageForm
            contacts={contacts}
            to={to}
            setTo={setTo}
            subject={subject}
            setSubject={setSubject}
            body={body}
            setBody={setBody}
            onChange={onChange}
            onSubmit={onSubmit}
            onClose={onClose}
            {...props}
        />
    );
}


export default MessageFormContainer;
